import { render, staticRenderFns } from "./TipoDocumentoTableComponent.vue?vue&type=template&id=192ba477&scoped=true&lang=pug"
import script from "./TipoDocumentoTableComponent.vue?vue&type=script&lang=js"
export * from "./TipoDocumentoTableComponent.vue?vue&type=script&lang=js"
import style0 from "./TipoDocumentoTableComponent.vue?vue&type=style&index=0&id=192ba477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192ba477",
  null
  
)

export default component.exports